import { useSelector } from 'react-redux';
import { ConnectWhatsapp, ErrorToastContainer } from '../../function/CustomFunction';
import { useEffect, useRef } from 'react';

export default function ApplyWhatsAppApiCard({ setLoder }) {
  const schedulingButtonRef = useRef(null);
  const services = useSelector((state) => state.serviceStore.value);

  // Load Google Calendar scheduling script
  useEffect(() => {
    // Load CSS
    const cssLink = document.createElement('link');
    cssLink.href = 'https://calendar.google.com/calendar/scheduling-button-script.css';
    cssLink.rel = 'stylesheet';
    document.head.appendChild(cssLink);

    // Load JavaScript
    const script = document.createElement('script');
    script.src = 'https://calendar.google.com/calendar/scheduling-button-script.js';
    script.async = true;
    
    script.onload = () => {
      if (window.calendar && schedulingButtonRef.current) {
        window.calendar.schedulingButton.load({
          url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ14o7X4U0Tnz-9S_yZvELi_FaXJk1a1bs5y9WBUlvwiK9mgOuFsqPWtuliprhF-RQ4RUZnGl8dz?gv=true',
          color: '#275c53',
          label: '📅 Schedule Meeting',
          description: 'Schedule a meeting with us',
          location: 'Online',
          padding: '12px 24px',
          fontSize: 10,
          borderRadius: 6,
          fontWeight: 200,
          target: schedulingButtonRef.current,
        });
      }
    };

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      document.head.removeChild(cssLink);
      document.head.removeChild(script);
    };
  }, []);

  // Handle WhatsApp connection
  const handleWhatsappConnection = async () => {
    if ((services?.whatsapp_connect ?? 0) === 1) {
      try {
        await ConnectWhatsapp(setLoder);
      } catch (error) {
        ErrorToastContainer('Connection failed. Please try again.');
      }
    } else {
      ErrorToastContainer('WhatsApp is not connected or your account is not eligible');
    }
  };

  return (
    <div className="wa-apply-card card border-0 shadow-sm" style={{
      background: '#ffffff',
      borderRadius: '16px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      padding: '28px 24px',
      marginTop: 24,
      marginBottom: 0,
      position: 'relative',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <span style={{
          background: '#275c53',
          color: '#fff',
          borderRadius: 6,
          fontWeight: 700,
          fontSize: 13,
          padding: '3px 12px',
        }}>START</span>
        <span className="wa-apply-heading" style={{ fontWeight: 700, fontSize: 16, color: '#1e293b' }}>
          Apply for WhatsApp Business API
        </span>
      </div>

      <div className="wa-apply-paragraph" style={{ fontSize: 13.5, color: '#475569', marginBottom: 10, lineHeight: 1.5 }}>
        To enable WhatsApp messaging for your business, connect your WhatsApp Business API account.<br/>
        Click <b>Continue With Facebook</b> to start the application process.
      </div>

      <div className="wa-apply-requirements" style={{ fontSize: 13, color: '#64748b', marginBottom: 10 }}>
        <b>Requirements:</b> A registered business and a working website.
      </div>

      <div style={{ fontSize: 13, color: '#64748b', marginBottom: 18 }}>
        <span role="img" aria-label="book" style={{ marginRight: 6 }}>📖</span>
        <a href="#" style={{ color: '#0ea5e9', textDecoration: 'underline' }}>
          How to apply for WhatsApp Business API?
        </a>
      </div>

      {/* Responsive 16:9 Video Container */}
      <div className="wa-apply-video-container" style={{ width: '100%', maxWidth: '560px', marginBottom: 20 }}>
        <div style={{
          position: 'relative',
          width: '100%',
          paddingBottom: '56.25%',
          height: 0,
          overflow: 'hidden',
          borderRadius: '12px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
        }}>
          <iframe
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0
            }}
            src="https://www.youtube.com/embed/n1rm5PHfmbs?si=zYiqj-UTzxV04YR4"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="wa-apply-btn-group" style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
        <div ref={schedulingButtonRef}></div>
        <button 
          className="wa-apply-fb-btn"
          onClick={handleWhatsappConnection} 
          style={{
            background: '#1877f2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '11px 22px',
            fontWeight: 600,
            fontSize: 14.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
        >
          Continue With Facebook
        </button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .wa-apply-card {
            padding: 20px 16px !important;
            border-radius: 14px !important;
            margin-top: 16px !important;
          }
          .wa-apply-heading {
            font-size: 15px !important;
          }
          .wa-apply-paragraph, .wa-apply-requirements {
            font-size: 13px !important;
          }
          .wa-apply-btn-group {
            flex-direction: column !important;
            align-items: stretch !important;
            width: 100% !important;
            gap: 10px !important;
          }
          .wa-apply-fb-btn {
            width: 100% !important;
            padding: 11px 16px !important;
            font-size: 14px !important;
          }
        }
      `}</style>
    </div>
  );
} 
